import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

class BookingConfirmAlert extends React.Component {
    handleClose = () => {
        this.props.close();
    };

    render() {

        return (
            <div>
                <Dialog
                    open={this.props.open}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogContent>
                        <DialogTitle>
                            Are You Sure?
                        </DialogTitle>
                        <DialogContentText id="alert-dialog-description">
                            ezPro will charge your payment method now and holds your funds until the Pro finishes the job and you verifiy the job is completed within 24 hours. You can also Reject the Pros work in order to get the Pro to fix any issues that remain related to your job so the Pro is not paid before the work is completed. You can cancel and be refunded before the job start time. You can also reschedule with the Pro as well. Do you want to continue?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.props.handleNo} color="primary">
                            No
                        </Button>
                        <Button
                            onClick={this.props.handleYes}
                            color="primary"
                            autoFocus
                        >
                            <span className='cnfirmbookingtest'>
                                Yes
                            </span>
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

export default BookingConfirmAlert;



// WEBPACK FOOTER //
// ./src/components/Alert/BookingConfirmAlert.jsx